import { render } from "./CentroCuentasMayorCero.vue?vue&type=template&id=89894a72&scoped=true"
import script from "./CentroCuentasMayorCero.vue?vue&type=script&lang=js"
export * from "./CentroCuentasMayorCero.vue?vue&type=script&lang=js"

import "./CentroCuentasMayorCero.vue?vue&type=style&index=0&id=89894a72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89894a72"]])

export default __exports__